import { Button, Flex, Text } from '@chakra-ui/react';
import Info from '@ui/components/Info';
import {
  ModalOrDrawerBodyWithMask,
  ModalOrDrawerFooter,
} from '@ui/components/ModalOrDrawer';
import { useStakedNfts } from '@ui/hooks/useCruisers';
import { useTranslations } from '@ui/i18n';
import React from 'react';

import NftSelection from '../GardenNftDrawersShared/NftSelection';
import {
  STEP,
  useGardenNftDrawerStore,
} from '../GardenNftDrawersShared/useGardenNftDrawer';
import { useGrowHelpers } from '../GrowHelpersProvider';

function DefaultContent() {
  const t = useTranslations();
  const { gardenType } = useGrowHelpers();
  const { data: stakedNfts } = useStakedNfts(gardenType);
  const { onClose, setStep, selectedTokens, setSelectedTokens } =
    useGardenNftDrawerStore();
  const deselectToken = (tokenId: string) =>
    setSelectedTokens(selectedTokens.filter((token) => token.id !== tokenId));

  return (
    <>
      <ModalOrDrawerBodyWithMask>
        <Text mx="auto" maxW="230px" textStyle="h3" textAlign="center">
          {t('Select the helpers you want to fire')}
        </Text>
        <Flex mt={6} gap={4} flexDir="column">
          <Info title={t('Helpers employed')} value={stakedNfts?.length} />
        </Flex>
        <NftSelection
          nfts={
            stakedNfts?.map((sc) => ({
              ...sc,
              imageUrl: sc.image.url,
              id: sc.tokenId,
            })) ?? []
          }
          selectedTokens={selectedTokens}
          onSelect={(id, collection) =>
            setSelectedTokens([...selectedTokens, { collection, id }])
          }
          onDeselect={deselectToken}
        />
      </ModalOrDrawerBodyWithMask>
      <ModalOrDrawerFooter>
        <Button
          onClick={() => setStep(STEP.confirming)}
          disabled={!selectedTokens.length}
        >
          {t('Confirm')}
        </Button>
        <Button mt={5} variant="link" onClick={onClose}>
          {t('Cancel')}
        </Button>
      </ModalOrDrawerFooter>
    </>
  );
}

export default DefaultContent;
